import { BadgesApiResponse } from '@repo/shared/domain';
import { constructQuery } from '@repo/shared/helpers';
import { guardedClient as clientRequest } from '@repo/shared/helpers';

export const getUserBadges = async (
	userId: string,
	params?: { page?: number; sort?: string },
): Promise<BadgesApiResponse> => {
	const query = constructQuery({
		page: params?.page,
		sort: params?.sort,
		userId,
	});
	const { body } = await clientRequest.get(`/api/badges?${query}`, {
		schema: undefined,
	});

	return body as BadgesApiResponse;
};
